"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.object.values");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AlignTypes = exports.AsideTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var AsideTypes = {
  RIGHT: 'right',
  LEFT: 'left'
};
exports.AsideTypes = AsideTypes;
var AlignTypes = {
  TOP: 'top',
  BOTTOM: 'bottom'
};
/**
 * @example
 * <Aside type={'right'} />
 * <Aside type={'right'} isSticky />
 */

exports.AlignTypes = AlignTypes;

var Aside = /*#__PURE__*/function (_React$Component) {
  _inherits(Aside, _React$Component);

  var _super = _createSuper(Aside);

  function Aside() {
    _classCallCheck(this, Aside);

    return _super.apply(this, arguments);
  }

  _createClass(Aside, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isSticky = _this$props.isSticky,
          type = _this$props.type,
          align = _this$props.align;
      var classes = (0, _classnames.default)({
        'l-aside': type === AsideTypes.LEFT,
        'l-complementary': type === AsideTypes.RIGHT,
        '--sticky': isSticky,
        '--align-bottom': align === AlignTypes.BOTTOM
      });
      return /*#__PURE__*/_react.default.createElement("aside", {
        id: "aside",
        className: classes,
        style: this.props.style
      }, this.props.children);
    }
  }], [{
    key: "Type",
    get: function get() {
      return AsideTypes;
    }
  }, {
    key: "Align",
    get: function get() {
      return AlignTypes;
    }
  }]);

  return Aside;
}(_react.default.Component);

Aside.defaultProps = {
  isSticky: false,
  type: AsideTypes.LEFT,
  style: {},
  children: null,
  align: AlignTypes.TOP
};
Aside.propTypes = {
  isSticky: _propTypes.default.bool,
  type: _propTypes.default.oneOf(Object.values(AsideTypes)),
  style: _propTypes.default.object,
  children: _propTypes.default.node,
  align: _propTypes.default.oneOf(Object.values(AlignTypes))
};
var _default = Aside;
exports.default = _default;
//# sourceMappingURL=Aside.js.map